import React from "react";
import {IContactUsData} from "../../../contracts/data/contact_us";

interface IContactUsDetails{
    contactUsData: IContactUsData
}

const ContactUsDetails:React.FC<IContactUsDetails> = ({contactUsData}) => {
    return(
        <React.Fragment>
            <div className={"py-2"}>
                <ul>
                    <li className={"mb-4"}>
                        <span className={"text-gray-500 ml-2 text-md"}>نام و نام خانوادگی:</span>
                        <span className={"text-lg"}>{contactUsData.fullname}</span>
                    </li>
                    <li className={"mb-4"}>
                        <span className={"text-gray-500 ml-2 text-md"}>شماره تماس:</span>
                        <span className={"text-lg"}>{contactUsData.mobile}</span>
                    </li>
                    <li className={"mb-4 bg-sky-100 rounded-lg p-2"}>
                        <div className={"text-gray-500 mb-2 text-md"}>متن پیام:</div>
                        <div className={"text-lg whitespace-pre-line"}>{contactUsData.content}</div>
                    </li>
                </ul>
            </div>
        </React.Fragment>
    )
}

export default ContactUsDetails